import Input from "../../Input"

const OnAdminsChannel = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full font-sans">
            <h6 className="flex justify-center">چنل ادمین های انلاین</h6>
            <div className="">
                <Input
                    type="number"
                    label="ایدی چنل *"
                    name={`onAdminsChannel-id`}
                    options={serverData?.channelList}
                    placeholder="ChannelID"
                    autoComplete="off"
                    dir="ltr"
                    defaultValue={values?.id}
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="ایدی رنک های ادمین:(با , میتوانید چند تا رنک وارد کنید) *"
                    name={`onAdminsChannel-adminSgList`}
                    options={serverData?.sgList}
                    multi={true}
                    placeholder="مثال: 1,2,3"
                    autoComplete="off"
                    defaultValue={values?.adminSgList}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="فرمت *"
                    name={`onAdminsChannel-format`}
                    placeholder="format"
                    autoComplete="off"
                    defaultValue={values?.format}
                    dir="ltr"
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%c: تعداد</div>
                </div>
            </div>
        </div>
    )
}

export default OnAdminsChannel
